import { render, staticRenderFns } from "./SearchDownload.vue?vue&type=template&id=8671fcce&scoped=true&"
import script from "./SearchDownload.vue?vue&type=script&lang=js&"
export * from "./SearchDownload.vue?vue&type=script&lang=js&"
import style0 from "./SearchDownload.vue?vue&type=style&index=0&id=8671fcce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8671fcce",
  null
  
)

export default component.exports